import { z } from 'zod';
export const getOrgChildrenIdsByParentIdFunctionDef = {
    name: 'getOrgChildrenIdsByParentId',
    requestSchema: z.object({
        parentId: z.string(),
        includeByMembership: z.boolean().optional(),
        includeVisible: z.boolean().optional(),
        includeByPermissions: z.string().array().optional(),
    }),
    responseSchema: z.string().array(),
};
